'use strict';

var Radio = require('backbone.radio');
var _ = require('underscore');
var $ = require('jquery');
var Backbone = require('backbone');
require('jquery-mask-plugin');

var SubmitView = require('./submit').default;
var polyglot = require('../../utilities/polyglot').default;

var TitleView = require('../step-title').default;
var SummaryView = require('../appointments/summary').default;
var FormView = require('../appointments/form').default;
var AttendeeFormView = require('../appointments/attendee-form').default;

export default SubmitView.extend({

  className: 'l-details-step',
  template: require('./templates/details.hbs'),
  defaultErrorMessage: polyglot.t('details.error'),

  ui: {
    add_attendee: '.add-attendee',
  },

  events: {
    'click @ui.add_attendee': 'onClickAddAttendee',
  },

  regions: function() {
    return {
      title: '.' + this.className + '-title',
      summary: '.' + this.className + '-summary',
      form: '.' + this.className + '-form',
    };
  },

  initialize: function() {
    this.titleView = new TitleView({
      title: polyglot.t('pages.details.long_title'),
    });
    this.summaryView = new SummaryView({ model: this.appointment });

    this.formView = new FormView({
      parentView: this,
      model: this.appointment,
    });

    this.clients = new Backbone.Collection();
    if (this.appointment.has('additionalClients')) {
      this.clients = this.appointment.get('additionalClients');
    }

    this.listenTo(this.formView, 'click:summary', this.onClickSummary);
    this.listenTo(this.formView, 'submit', this.onFormSubmit);
    this.listenTo(this.formView, 'next', this.onFormNext);
  },

  onRender: function() {
    this.getRegion('title').show(this.titleView);
    this.getRegion('form').show(this.formView);
    this.getRegion('summary').show(this.summaryView);
  },

  onDomRefresh: function() {
    this.formView.focus();
  },

  onClickAddAttendee: function (event) {
    event.preventDefault();

    Radio.channel('modal').trigger('show', new AttendeeFormView({
      model: this.appointment,
      parentView: this,
    }), 'modal-attendee-form');
  },

  onClickEditAttendee: function (attendeeView) {
    Radio.channel('modal').trigger('show', new AttendeeFormView({
      attendeeView,
      model: this.appointment,
      parentView: this,
    }), 'modal-attendee-form');
  },

  createAttendeeEditListener: function (view) {
    this.listenTo(view, 'click:edit-attendee', () => this.onClickEditAttendee(view));
  },

  onFormNext: function() {
    this.appointment.get('client')[0].answers = this.appointment.get('answers');
    this.appointment.set('client', [...this.appointment.get('client'), ...this.clients.toJSON()]);
  },

  onFormSubmit: function() {
    this.appointment.set('client_timezone', window.localStorage.getItem('timezone'));

    if (window.REQUEST_START) {
      this.appointment.set('booked_through', window.CONSTANTS.ORIGIN_WAIT_LIST);
      this.appointment.set('request_id', window.REQUEST.id);
    }

    if (typeof this.appointment.get('start') !== 'string') {
      var start = this.appointment.get('start')
        .tz(this.appointment.getLocation().get('timezone'))
        .format('YYYY-MM-DD HH:mm:ss');
      this.appointment.set('start', start);
    }

    this.appointment.set('shortcuts', [
      ...(window.LOCATION ? [window.CONSTANTS.LOCATION] : []),
      ...(window.SERVICE ? [window.CONSTANTS.SERVICE] : []),
      ...(window.STAFF ? [window.CONSTANTS.STAFF] : []),
    ]);

    this.appointment.get('client')[0].answers = this.appointment.get('answers');
    this.appointment.set('client', [...this.appointment.get('client'), ...this.clients.toJSON()]);

    var options = { _token: $('meta[name="csrf-token"]').attr('content') };

    this.appointment.save(options)
      .done(_.bind(this.onSaveSuccess, this))
      .fail(_.bind(this.onSaveError, this));
  },

  onClickSummary: function() {
    Radio.channel('modal').trigger('show', new SummaryView({ model: this.appointment }));
  },
});
